import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

export const setToken = (t) => {
  if (t) {
    localStorage.setItem("db_token", t);
    api.defaults.headers.common.Authorization = `Bearer ${t}`;
  } else {
    localStorage.removeItem("db_token");
    delete api.defaults.headers.common.Authorization;
  }
};

export const errMsg = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ") || fallback;
  return e?.message || fallback;
};

export const short = (a, n = 4) => (a ? `${a.slice(0, n)}…${a.slice(-n)}` : "—");

export const usd = (v, d = 2) =>
  v === null || v === undefined ? "—" : `$${Number(v).toLocaleString(undefined, { minimumFractionDigits: d, maximumFractionDigits: d })}`;

export const signedUsd = (v) => (v === null || v === undefined ? "—" : `${v >= 0 ? "+" : "-"}${usd(Math.abs(v))}`);

export const pct = (v) => (v === null || v === undefined ? "—" : `${v >= 0 ? "+" : ""}${Number(v).toFixed(1)}%`);

export const price = (v) => {
  if (!v) return "—";
  if (v >= 1) return `$${v.toFixed(4)}`;
  const s = v.toExponential(3);
  return v < 0.0001 ? `$${s}` : `$${v.toFixed(7)}`;
};

export const tone = (v) => (v > 0 ? "text-[#14F195]" : v < 0 ? "text-[#EF4444]" : "text-slate-400");

export const ago = (iso) => {
  if (!iso) return "—";
  const s = Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 1000));
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
};
